var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alarm-Page" },
    [
      _c("childNav", {
        attrs: { routerName: _vm.$t("breadcrumbItem.alarm"), backFlag: true },
      }),
      _c("div", { staticClass: "page-body" }, [
        _c(
          "div",
          { staticClass: "page-box" },
          [
            _c(
              "Row",
              { staticClass: "row-margin" },
              [
                _c(
                  "i-col",
                  { staticClass: "text-left", attrs: { span: 20 } },
                  [
                    _c(
                      "RadioGroup",
                      {
                        attrs: {
                          type: "button",
                          "button-style": "solid",
                          size: "large",
                        },
                        model: {
                          value: _vm.addForm.zoneMode,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "zoneMode", $$v)
                          },
                          expression: "addForm.zoneMode",
                        },
                      },
                      _vm._l(_vm.alarmList, function (item, index) {
                        return _c(
                          "Radio",
                          {
                            key: index,
                            attrs: { label: item.value, border: "" },
                          },
                          [_c("span", [_vm._v(_vm._s(item.label))])]
                        )
                      }),
                      1
                    ),
                    _c(
                      "RadioGroup",
                      {
                        staticClass: "radio-item",
                        attrs: {
                          type: "button",
                          "button-style": "solid",
                          size: "large",
                        },
                        model: {
                          value: _vm.addForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "name", $$v)
                          },
                          expression: "addForm.name",
                        },
                      },
                      _vm._l(_vm.nameList, function (item, index) {
                        return _c(
                          "Radio",
                          {
                            key: index,
                            attrs: { label: item.value, border: "" },
                          },
                          [_c("span", [_vm._v(_vm._s(item.label))])]
                        )
                      }),
                      1
                    ),
                    _c(
                      "Checkbox",
                      {
                        staticClass: "radio-item",
                        attrs: { size: "large", border: "" },
                        model: {
                          value: _vm.addForm.exZone,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "exZone", $$v)
                          },
                          expression: "addForm.exZone",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("alarm.alarmPlus")))]
                    ),
                  ],
                  1
                ),
                _c(
                  "i-col",
                  { staticClass: "text-right", attrs: { span: 4 } },
                  [
                    _c(
                      "Poptip",
                      {
                        attrs: { placement: "bottom" },
                        model: {
                          value: _vm.visible,
                          callback: function ($$v) {
                            _vm.visible = $$v
                          },
                          expression: "visible",
                        },
                      },
                      [
                        _c(
                          "Button",
                          { attrs: { type: "info", size: "large" } },
                          [_vm._v(_vm._s(_vm.$t("alarm.timeSet")))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "poptip-body",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c(
                              "Form",
                              {
                                ref: "timeForm",
                                attrs: {
                                  "label-position": "right",
                                  "label-width": 130,
                                  model: _vm.timeForm,
                                  rules: _vm.ruleValidate,
                                },
                              },
                              [
                                _c(
                                  "FormItem",
                                  {
                                    attrs: { label: _vm.$t("alarm.delayTime") },
                                  },
                                  [
                                    _c("InputNumber", {
                                      staticClass: "num-input",
                                      attrs: {
                                        max: 250,
                                        min: 1,
                                        size: "large",
                                        clearable: "",
                                        "active-change": false,
                                      },
                                      model: {
                                        value: _vm.timeForm.activeDelay,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.timeForm,
                                            "activeDelay",
                                            $$v
                                          )
                                        },
                                        expression: "timeForm.activeDelay",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "FormItem",
                                  {
                                    attrs: {
                                      label: _vm.$t("alarm.startDelay"),
                                    },
                                  },
                                  [
                                    _c("InputNumber", {
                                      staticClass: "num-input",
                                      attrs: {
                                        max: 250,
                                        min: 1,
                                        size: "large",
                                        clearable: "",
                                        "active-change": false,
                                      },
                                      model: {
                                        value: _vm.timeForm.triggerDelay,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.timeForm,
                                            "triggerDelay",
                                            $$v
                                          )
                                        },
                                        expression: "timeForm.triggerDelay",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "FormItem",
                                  {
                                    attrs: { label: _vm.$t("alarm.startUtil") },
                                  },
                                  [
                                    _c("InputNumber", {
                                      staticClass: "num-input",
                                      attrs: {
                                        max: 30,
                                        min: 5,
                                        size: "large",
                                        clearable: "",
                                        "active-change": false,
                                      },
                                      model: {
                                        value: _vm.timeForm.duration,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.timeForm,
                                            "duration",
                                            $$v
                                          )
                                        },
                                        expression: "timeForm.duration",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "btn-box" },
                              [
                                _c(
                                  "Button",
                                  {
                                    staticClass: "btn-margin",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.closePop },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.ensure")))]
                                ),
                                _c(
                                  "Button",
                                  {
                                    staticClass: "btn-margin",
                                    on: { click: _vm.resetForm },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.reset")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("Table", {
              staticClass: "table-margin",
              attrs: {
                columns: _vm.currentColunm,
                stripe: "",
                border: "",
                data: _vm.currentList,
              },
              on: {
                click: function ($event) {
                  return _vm.test(111)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "open",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c(
                        "i-switch",
                        {
                          attrs: {
                            size: "large",
                            "true-value": 1,
                            "false-value": 0,
                            "before-change": _vm.beforeChange.bind(this, row),
                          },
                          on: {
                            "on-change": function ($event) {
                              return _vm.setOpen(row.open, index, row)
                            },
                          },
                          model: {
                            value: row.open,
                            callback: function ($$v) {
                              _vm.$set(row, "open", $$v)
                            },
                            expression: "row.open",
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "open" }, slot: "open" },
                            [_vm._v(_vm._s(_vm.$t("alarm.open")))]
                          ),
                          _c(
                            "span",
                            { attrs: { slot: "close" }, slot: "close" },
                            [_vm._v(_vm._s(_vm.$t("alarm.close")))]
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "sensor",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c(
                        "Select",
                        {
                          attrs: { size: "large", clearable: "" },
                          on: {
                            "on-change": function ($event) {
                              return _vm.setMachine(row.sensor, index)
                            },
                          },
                          model: {
                            value: row.sensor,
                            callback: function ($$v) {
                              _vm.$set(row, "sensor", $$v)
                            },
                            expression: "row.sensor",
                          },
                        },
                        _vm._l(_vm.machineList, function (item, index) {
                          return _c(
                            "Option",
                            { key: index, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "trigger",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c(
                        "Select",
                        {
                          ref: "trigger" + [index],
                          attrs: {
                            "element-id": "trigger" + [index],
                            size: "large",
                            clearable: "",
                          },
                          on: {
                            "on-change": function ($event) {
                              return _vm.setSendType(row.trigger, index, row)
                            },
                          },
                          model: {
                            value: row.trigger,
                            callback: function ($$v) {
                              _vm.$set(row, "trigger", $$v)
                            },
                            expression: "row.trigger",
                          },
                        },
                        _vm._l(_vm.sendList, function (item, index) {
                          return _c(
                            "Option",
                            { key: index, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "mode",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c(
                        "i-switch",
                        {
                          attrs: {
                            size: "large",
                            "true-value": 1,
                            "false-value": 0,
                          },
                          on: {
                            "on-change": function ($event) {
                              return _vm.setMode(row.mode, index)
                            },
                          },
                          model: {
                            value: row.mode,
                            callback: function ($$v) {
                              _vm.$set(row, "mode", $$v)
                            },
                            expression: "row.mode",
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "open" }, slot: "open" },
                            [_vm._v(_vm._s(_vm.$t("alarm.mode1")))]
                          ),
                          _c(
                            "span",
                            { attrs: { slot: "close" }, slot: "close" },
                            [_vm._v(_vm._s(_vm.$t("alarm.mode2")))]
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "associated",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c("InputNumber", {
                        attrs: {
                          max: _vm.addForm.exZone ? 24 : 8,
                          min: 1,
                          size: "large",
                          clearable: "",
                          "active-change": false,
                        },
                        on: {
                          "on-change": function ($event) {
                            return _vm.setAssociated(row.associated, index)
                          },
                        },
                        model: {
                          value: row.associated,
                          callback: function ($$v) {
                            _vm.$set(row, "associated", $$v)
                          },
                          expression: "row.associated",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "Row",
              {
                staticClass: "table-margin",
                class: { "page-opact": _vm.addForm.exZone !== true },
              },
              [
                _c(
                  "i-col",
                  { staticClass: "text-center", attrs: { span: 24 } },
                  [
                    _c("Page", {
                      attrs: {
                        current: _vm.pageIndex,
                        total: _vm.itemTotal,
                        "show-total": "",
                        "page-size": _vm.pageSize,
                      },
                      on: { "on-change": _vm.getPageList },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "submit-btn" },
              [
                _c(
                  "Button",
                  {
                    attrs: { type: "success", size: "large" },
                    on: { click: _vm.submitList },
                  },
                  [_vm._v(_vm._s(_vm.$t("openConfig.produce")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content_win" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }